module.exports = __webpack_public_path__ + "static/media/karbar.80249ade.png";